module.exports = __webpack_public_path__ + "static/bayarea-fee3d9c7eed3fc3a88f7816bf76aa3fe.jpg";